const Widget = {
  props: ['user', 'range', 'imports'],

  created () {
    this.get();
  },

  mounted () {
    this.$watch('user', () => this.get());
    this.$watch('range', () => this.get());
    this.$watch('imports', () => this.get());
  },

  data () {
    return {
      loading: false,
      data: {},
    };
  },

  methods: {
    get () {
      this.loading = true;

      const params = {
        range: this.range,
        user_id: this.user_id,
        imports: this.imports ? 1 : 0,
      };

      this.$http.get(`/widget/${this.name}`, { params })
        .then((response) => {
          this.data = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};

export default Widget;
